/* NDOZI — reveal + parallax + countdown + FAQ + sticky CTA */
(function () {
  'use strict';

  /* ---------- 1. Reveal au scroll ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.nd-reveal:not(.nd-bound)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in', 'nd-bound'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.classList.add('nd-bound'); io.observe(el); });
  }

  /* ---------- 2. Compte à rebours (persistant 72h par défaut) ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown() {
    var nodes = document.querySelectorAll('[data-nd-cd]');
    if (!nodes.length) return;

    var host = document.querySelector('[data-nd-cd-hours]');
    var hours = host ? parseInt(host.getAttribute('data-nd-cd-hours'), 10) : 72;
    if (!hours || isNaN(hours)) hours = 72;

    var KEY = 'ndozi_launch_deadline';
    var deadline;
    try {
      var stored = localStorage.getItem(KEY);
      if (stored) deadline = parseInt(stored, 10);
      if (!deadline || isNaN(deadline) || deadline < Date.now()) {
        deadline = Date.now() + hours * 3600 * 1000;
        localStorage.setItem(KEY, String(deadline));
      }
    } catch (e) {
      deadline = Date.now() + hours * 3600 * 1000;
    }

    function tick() {
      var rem = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      var v = {
        h: pad(Math.floor(rem / 3600)),
        m: pad(Math.floor((rem % 3600) / 60)),
        s: pad(rem % 60)
      };
      document.querySelectorAll('[data-nd-cd]').forEach(function (el) {
        var k = el.getAttribute('data-nd-cd');
        if (v[k] !== undefined) el.textContent = v[k];
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- 3. Parallax hero ---------- */
  var parallaxEl = null;
  var stickyEl = null;

  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    if (parallaxEl) parallaxEl.style.transform = 'translateY(' + (y * 0.05) + 'px)';
    if (stickyEl) stickyEl.classList.toggle('is-visible', y > window.innerHeight * 0.95);
  }

  /* ---------- 4. FAQ accordéon ---------- */
  function initFaq() {
    document.querySelectorAll('.nd-faq-q:not(.nd-bound)').forEach(function (btn) {
      btn.classList.add('nd-bound');
      btn.addEventListener('click', function () {
        var item = btn.closest('.nd-faq');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var sign = item.querySelector('[data-nd-faq-sign]');
        if (sign) sign.textContent = open ? '\u2013' : '+';
      });
    });
  }

  /* ---------- 5. Scroll vers l'offre ---------- */
  function initScrollLinks() {
    document.querySelectorAll('[data-nd-scroll]:not(.nd-bound)').forEach(function (el) {
      el.classList.add('nd-bound');
      el.addEventListener('click', function (ev) {
        var target = el.getAttribute('data-nd-scroll');
        if (!target) return;
        var dest = target === 'top' ? null : document.querySelector(target);
        if (target === 'top') {
          ev.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (dest) {
          ev.preventDefault();
          var top = dest.getBoundingClientRect().top + (window.scrollY || 0) - 12;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }

  function boot() {
    parallaxEl = document.querySelector('[data-nd-parallax]');
    stickyEl = document.querySelector('.nd-sticky');
    initReveal(document);
    initCountdown();
    initFaq();
    initScrollLinks();
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* Éditeur de thème : re-brancher après un rendu de section */
  document.addEventListener('shopify:section:load', boot);
})();
